import { LoadingHandler, StateErrorDisplay, shapes } from '@greenville/framework';
import { Checkbox, FormControlLabel, FormGroup, Grid, Paper, styled } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CloseIcon from '@material-ui/icons/Close';
import { Box, Card, CardContent } from '@mui/material';
import Button from '@mui/material/Button';
import CardHeader from '@mui/material/CardHeader';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import { PropTypes } from 'prop-types';
import React, { useEffect, useState } from 'react';
import Loader from '../../../../common/Loader';
import * as constants from '../../../../common/constants';
import SubTypeResponse from '../../models/SubTypeModel';
import utils from '../../../../common/utils';
import MathJaxWrapper from '../../common/components/MathJaxWrapper';

const styles = (theme) => ({
  root: {
    width: '100%'
  },
  metaRoot: {
    '& .MuiTableCell-root': {
      padding: theme.spacing(0.6)
    }
  },
  titleAuthorPadding: {
    paddingTop: theme.spacing(1)
  },
  paper: {
    padding: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  titleMargin: {
    marginLeft: 'inherit',
    marginRight: 'inherit',
    marginBottom: theme.spacing(1.5)
  },
  contentMargin: {
    marginLeft: 'inherit',
    marginRight: 'inherit',
    marginBottom: 'inherit',
    '& .MuiDialogContent-root:first-child': {
      paddingTop: '12px'
    }
  },
  dialogContent: {
    padding: '4px 20px'
  },
  dialogPaper: {
    minHeight: '60vh',
    maxWidth: '80%'
  },
  tableText: {
    textAlign: 'center',
    color: '#6a7070',
    fontSize: 13
  },
  bookInfoText: {
    color: '#6a7070',
    fontSize: 13,
    paddingLeft: theme.spacing(0.6)
  },
  statusText: {
    textAlign: 'center',
    fontSize: 13
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(0.7),
    color: theme.palette.grey[700]
  },
  aiStudyToolcard: {
    height: '435px',
    overflowY: 'auto !important'
  },
  inCreaseAiStudyToolcard: {
    overflowY: 'auto !important',
    height: '585px'
  },
  promptCard: {
    overflowY: 'auto !important',
    maxHeight: '235px',
    minHeight: '235px'
  },
  minimizedPromptCard: {
    overflowY: 'auto !important',
    height: '130px'
  },
  chatIntentCard: {
    overflowY: 'auto !important',
    height: '200px'
  },
  subTypeModel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

const TopicQuizDialogComponent = ({
  classes,
  openChat,
  dataValue,
  handleClose,
  userTocDetails,
  dataLength,
  filterPromt,
  modalIndex,
  handleModalChange,
  chatgptUtilityResponseStatus,
  loaderStatusResponse,
  ChatUtilitySubTypeResponse,
  chatgptUtilitySubTypeResponseStatus
}) => {
  const { SubTypeData } = ChatUtilitySubTypeResponse;
  const [checkboxSelectedValue, setCheckboxSelectedValue] = useState({});
  const [firstQuizSet, setFirstQuizSet] = useState(null);
  const [secondQuizSet, setSecondQuizSet] = useState(null);
  const [checked, setChecked] = useState({
    aiStudyTools: false,
    problemSolveFinalRes: false,
    problemSolveRawRectifier: false
  });

  useEffect(() => {
    if (Object.keys(checkboxSelectedValue).length === 0) {
      ChatUtilitySubTypeResponse.resetStoreValues();
    }
  }, [chatgptUtilityResponseStatus, checkboxSelectedValue, dataValue, chatgptUtilitySubTypeResponseStatus]);

  useEffect(() => {
    if (!_.isEmpty(dataValue) && !chatgptUtilitySubTypeResponseStatus.isPending) {
      const [quizSetOne, quizSetTwo] = utils.splitQuizData(dataValue);
      setFirstQuizSet(quizSetOne);
      setSecondQuizSet(quizSetTwo);
    }
  }, [dataValue, chatgptUtilitySubTypeResponseStatus]);

  const handleNavigationChange = (nav) => {
    handleModalChange(nav);
    setCheckboxSelectedValue({});
    setChecked({ ...checked, aiStudyTools: false, problemSolveFinalRes: false, problemSolveRawRectifier: false });
    ChatUtilitySubTypeResponse.resetStoreValues();
  };
  const handleSelectedValue = (event) => {
    let sourceType = '';
    const { requestId, bookId } = dataValue[0];
    if (event.target.checked) {
      sourceType = event.target.value;
    } else {
      sourceType = dataValue.mainType;
    }
    const { value } = event.target;
    if (value === 'chat_intent') {
      setCheckboxSelectedValue({ ...checkboxSelectedValue, chat_intent: !checkboxSelectedValue.chat_intent });
    } else if (value === 'content_filter') {
      setCheckboxSelectedValue({ ...checkboxSelectedValue, content_filter: !checkboxSelectedValue.content_filter });
    } else if (value === constants.GENERATE_PYTHON) {
      setCheckboxSelectedValue({ ...checkboxSelectedValue, GENERATE_PYTHON: !checkboxSelectedValue.GENERATE_PYTHON });
    } else {
      setCheckboxSelectedValue({
        ...checkboxSelectedValue,
        explain_stand_alone: !checkboxSelectedValue.explain_stand_alone
      });
    }
    if (sourceType && dataValue[0]?.type !== constants.GENERATE_PYTHON) {
      if (SubTypeData.length > 0) {
        const findValue = SubTypeData.find((data) => data.requestId === requestId && data.type === sourceType);
        if (!findValue) {
          ChatUtilitySubTypeResponse.fetch({ requestId, bookId, type: sourceType });
        }
      } else {
        ChatUtilitySubTypeResponse.fetch({ requestId, bookId, type: sourceType });
      }
    }
  };

  const renderMathJaxResponse = (response) => {
    const regesXmlns = /<math([^>]*)>/g;
    const res = utils.containsMathML(response)
      ? response.replace(regesXmlns, '<math xmlns="http://www.w3.org/1998/Math/MathML">')
      : response;

    return (
      <MathJaxWrapper>
        {/* eslint-disable */}
        <span dangerouslySetInnerHTML={{ __html: utils.renderLinksVideos(res) }} />
        {/* eslint-disable */}
      </MathJaxWrapper>
    );
  };

  const checkMathJax = (mathJaxData) => {
    let response = mathJaxData;
    if (!_.isEmpty(mathJaxData)) {
      if (utils.containsMarkDownText(mathJaxData)) {
        response = utils.convertToMarkedDownString(mathJaxData);
      }
      if (response.includes('`') || response.includes('</math>') || response.includes('\\'))
        return renderMathJaxResponse(response);
    }

    return (
      <>
        {/* eslint-disable-next-line */}
        <div dangerouslySetInnerHTML={{ __html: utils.renderLinksVideos(response) }} />
      </>
    );
  };

  const objectIteration = (item) => {
    if (item && Object.keys(item).length > 0 && !Array.isArray(item) && typeof item !== 'string') {
      return Object.entries(item).map(([key, value]) => {
        if (Array.isArray(value)) {
          return (
            <>
              {objectIteration(value)} <br />
            </>
          );
        }
        return (
          <Typography variant="body2" color="text.secondary" textAlign="left">
            {checkMathJax(`${key} : ${value} `)}
          </Typography>
        );
      });
    } else if (item && Array.isArray(item)) {
      return item.map((str) => {
        return (
          <>
            {objectIteration(str)}
            <br />
          </>
        );
      });
    }
    return (
      <Typography variant="body2" color="text.secondary" textAlign="left">
        {checkMathJax(item)}
      </Typography>
    );
  };

  return (
    <>
      <Dialog fullScreen open={openChat} onClose={handleClose}>
        <Box sx={{ p: 2 }}>
          <Paper elevation={0}>
            <Grid container spacing={0} padding={0}>
              <Grid item xs={5}>
                <Typography align="left" variant="subtitle1">
                  {constants.CHAT_USERLOGIN}: {dataValue[0]?.userId}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography align="left" display="inline">
                  <Stack
                    display="inline"
                    spacing={0}
                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                  >
                    <Button disabled={modalIndex === 0} onClick={() => handleNavigationChange('prev')} size="large">
                      <ChevronLeftIcon />
                    </Button>
                    <span color="secondary">{modalIndex + 1}</span> /<span color="secondary"> {dataLength}</span>
                    <Button disabled={modalIndex + 1 === dataLength} onClick={() => handleNavigationChange('next')}>
                      <ChevronRightIcon />
                    </Button>
                    {dataValue && dataValue[0]?.type && <Typography>Quiz</Typography>}
                  </Stack>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography align="right" variant="subtitle1">
                  {Object.keys(dataValue).length > 0 ? (
                    <Typography display="inline" variant="subtitle2">
                      <span>{`${dataValue && dataValue[0]?.serverDateTime}  (GMT) `}</span>
                      <Box display="inline" sx={{ pl: 4 }}>
                        <IconButton edge="start" color="default" onClick={() => handleClose()} aria-label="close">
                          <Tooltip title="Close">
                            <CloseIcon />
                          </Tooltip>
                        </IconButton>
                      </Box>
                    </Typography>
                  ) : (
                    <span> </span>
                  )}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={0} padding={0} className={classes.subTypeModel}>
              <Stack sx={{ alignItems: 'center' }}>
                <FormGroup
                  display="inline"
                  spacing={0}
                  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                >
                  {constants.QUIZ_CHAIN_TYPES.includes(dataValue[0]?.type) && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkboxSelectedValue && checkboxSelectedValue.chat_intent === true}
                          color="primary"
                          value="chat_intent"
                          onChange={(e) => handleSelectedValue(e)}
                        />
                      }
                      label="Include Chat Intent"
                      style={{ alignItems: 'center', padding: '0px' }}
                    />
                  )}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkboxSelectedValue && checkboxSelectedValue.content_filter === true}
                        color="primary"
                        value="content_filter"
                        onChange={(e) => handleSelectedValue(e)}
                      />
                    }
                    label="Include Content Filter"
                    style={{ alignItems: 'center', padding: '0px' }}
                  />
                </FormGroup>
              </Stack>
            </Grid>
          </Paper>
        </Box>
        <Box sx={{ p: 2, paddingTop: '0px' }}>
          <Box>
            <LoadingHandler
              loading={chatgptUtilityResponseStatus.isPending || chatgptUtilitySubTypeResponseStatus.isPending}
              isError={
                (chatgptUtilityResponseStatus.isError &&
                  chatgptUtilityResponseStatus.error &&
                  chatgptUtilityResponseStatus.error.status === 401 &&
                  chatgptUtilityResponseStatus.error.status === 500) ||
                (chatgptUtilitySubTypeResponseStatus.isError &&
                  chatgptUtilitySubTypeResponseStatus.error &&
                  chatgptUtilitySubTypeResponseStatus.error.status === 401 &&
                  chatgptUtilitySubTypeResponseStatus.error.status === 500)
              }
              content={<></>}
              loadingContent={<Loader loaderStatusResponse={loaderStatusResponse} />}
              errorContent={
                <StateErrorDisplay
                  error={chatgptUtilityResponseStatus.error || chatgptUtilitySubTypeResponseStatus.error}
                  showDetails
                />
              }
            />
          </Box>
          <Grid container spacing={2} style={{ minWidth: 800 }}>
            <Grid item xs={6}>
              <Grid item xs={12}>
                <Item>
                  <Card style={{ overflowY: 'auto', maxHeight: '145px', minHeight: '145px' }}>
                    <CardHeader title="User Input/Command" style={{ background: '#34282808' }} align="left" />
                    <CardContent>
                      <Typography variant="body2" color="text.primary" textAlign="left">
                        {dataValue && dataValue[0]?.question}
                        {userTocDetails &&
                          Object.keys(userTocDetails).map((val) => {
                            return <Typography variant="h6">{`: ${val.sectionName}`}</Typography>;
                          })}
                      </Typography>
                      <Typography variant="body2" color="text.primary" textAlign="left">
                        {dataValue && dataValue.userCommand}
                      </Typography>
                    </CardContent>
                  </Card>
                </Item>
              </Grid>
              <br />
              {dataValue && (
                <>
                  <Grid>
                    <Item>
                      <Card
                        className={
                          dataValue.type === 'content_filter' ? classes.minimizedPromptCard : classes.promptCard
                        }
                      >
                        <CardHeader
                          title={`${constants.CHAT_PROMPT_CONTENT} - Quiz Practice 1`}
                          style={{ background: '#34282808' }}
                          align="left"
                        />
                        <CardContent>
                          <Typography variant="body2" color="text.secondary" textAlign="left">
                            {firstQuizSet?.[0]?.content}
                          </Typography>
                          <br />

                          {firstQuizSet?.[0]?.prompts.map((prompt, i) => (
                            <Typography key={i} variant="body2" color="text.secondary" align="left">
                              {`${prompt.name} Version = ${prompt.version} (${prompt.status})`}
                            </Typography>
                          ))}

                          {filterPromt.includes(firstQuizSet?.[0].type) &&
                          firstQuizSet?.[0].prompt &&
                          typeof firstQuizSet?.[0].prompt === 'object' ? (
                            firstQuizSet?.[0].prompt.map((data) => {
                              return (
                                <>
                                  <Typography
                                    variant="body2"
                                    color="text.primary"
                                    textAlign="center"
                                  >{`Role: ${data.role}`}</Typography>
                                  {data.prompt && (
                                    <>
                                      <Typography variant="body2" color="text.primary" textAlign="left">
                                        {constants.CHAT_PROMPT}:
                                      </Typography>{' '}
                                      <Typography variant="body2" color="text.secondary" textAlign="left">
                                        {data.prompt.toString().replace(/\n/g, '\\n')}
                                      </Typography>
                                      <br />
                                    </>
                                  )}
                                  {data.safety && (
                                    <>
                                      <Typography variant="body2" color="text.primary" textAlign="left">
                                        {constants.CHAT_SAFETY}:
                                      </Typography>
                                      <Typography variant="body2" color="text.secondary" textAlign="left">
                                        {data.safety}
                                      </Typography>
                                      <br />
                                    </>
                                  )}
                                  {data.userTopic && (
                                    <>
                                      <Typography variant="body2" color="text.primary" textAlign="left">
                                        {constants.CHAT_USERTOPIC}:
                                      </Typography>
                                      <Typography variant="body2" color="text.secondary" textAlign="left">
                                        {data.userTopic}
                                      </Typography>
                                      <br />
                                    </>
                                  )}
                                </>
                              );
                            })
                          ) : (
                            <Typography variant="body2" color="text.secondary" textAlign="left">
                              {firstQuizSet?.[0] &&
                                firstQuizSet?.[0].prompt &&
                                firstQuizSet?.[0].prompt.toString().replace(/\n/g, '\\n')}
                            </Typography>
                          )}
                        </CardContent>
                      </Card>
                    </Item>
                  </Grid>
                  <br />
                  <Grid>
                    <Item>
                      <Card
                        className={
                          dataValue.type === 'content_filter' ? classes.minimizedPromptCard : classes.promptCard
                        }
                      >
                        <CardHeader
                          title={`${constants.CHAT_PROMPT_CONTENT} - Quiz Practice 2`}
                          style={{ background: '#34282808' }}
                          align="left"
                        />
                        <CardContent>
                          <Typography variant="body2" color="text.secondary" textAlign="left">
                            {secondQuizSet?.[0]?.content}
                          </Typography>
                          <br />
                          {secondQuizSet?.[0]?.prompts.map((prompt, i) => (
                            <Typography key={i} variant="body2" color="text.secondary" align="left">
                              {`${prompt.name} Version = ${prompt.version} (${prompt.status})`}
                            </Typography>
                          ))}
                          {filterPromt.includes(secondQuizSet?.[0].type) &&
                          secondQuizSet?.[0].prompt &&
                          typeof secondQuizSet?.[0].prompt === 'object' ? (
                            secondQuizSet?.[0].prompt.map((data) => {
                              return (
                                <>
                                  <Typography
                                    variant="body2"
                                    color="text.primary"
                                    textAlign="center"
                                  >{`Role: ${data.role}`}</Typography>
                                  {data.prompt && (
                                    <>
                                      <Typography variant="body2" color="text.primary" textAlign="left">
                                        {constants.CHAT_PROMPT}:
                                      </Typography>{' '}
                                      <Typography variant="body2" color="text.secondary" textAlign="left">
                                        {data.prompt.toString().replace(/\n/g, '\\n')}
                                      </Typography>
                                      <br />
                                    </>
                                  )}
                                  {data.safety && (
                                    <>
                                      <Typography variant="body2" color="text.primary" textAlign="left">
                                        {constants.CHAT_SAFETY}:
                                      </Typography>
                                      <Typography variant="body2" color="text.secondary" textAlign="left">
                                        {data.safety}
                                      </Typography>
                                      <br />
                                    </>
                                  )}
                                  {data.userTopic && (
                                    <>
                                      <Typography variant="body2" color="text.primary" textAlign="left">
                                        {constants.CHAT_USERTOPIC}:
                                      </Typography>
                                      <Typography variant="body2" color="text.secondary" textAlign="left">
                                        {data.userTopic}
                                      </Typography>
                                      <br />
                                    </>
                                  )}
                                </>
                              );
                            })
                          ) : (
                            <Typography variant="body2" color="text.secondary" textAlign="left">
                              {secondQuizSet?.[0] &&
                                secondQuizSet?.[0].prompt &&
                                secondQuizSet?.[0].prompt.toString().replace(/\n/g, '\\n')}
                            </Typography>
                          )}
                        </CardContent>
                      </Card>
                    </Item>
                  </Grid>
                </>
              )}

              {SubTypeData &&
                SubTypeData.map((typeData) => {
                  if (checkboxSelectedValue.content_filter === true && typeData && typeData.type === 'content_filter') {
                    return (
                      <>
                        <br />
                        <Item>
                          <Card className={classes.chatIntentCard}>
                            <CardHeader
                              title="Content Filter Response"
                              style={{ background: '#34282808' }}
                              align="left"
                            />
                            <CardContent>
                              {typeData &&
                                typeData.type === 'content_filter' &&
                                typeData.botResponse &&
                                Object.keys(typeData.botResponse).length > 0 &&
                                Object.keys(typeData.botResponse).map((key) => {
                                  if (key === 'Category_Severity') {
                                    return typeData.botResponse[key].map((data) => {
                                      return (
                                        <>
                                          <Typography variant="body2" color="text.secondary" textAlign="left">
                                            Category : {data.Category}
                                          </Typography>
                                          <Typography variant="body2" color="text.secondary" textAlign="left">
                                            Severity : {data.Severity}
                                          </Typography>
                                        </>
                                      );
                                    });
                                  }
                                  return <></>;
                                })}
                            </CardContent>
                          </Card>
                        </Item>
                      </>
                    );
                  }
                  return <></>;
                })}
            </Grid>
            <br />
            <Grid item xs={6}>
              <>
                <Item>
                  <Card
                    className={
                      dataValue.type === 'content_filter' ? classes.inCreaseAiStudyToolcard : classes.aiStudyToolcard
                    }
                  >
                    <CardHeader
                      title="AI Study Tool Response - Quiz Practice 1"
                      style={{ background: '#34282808' }}
                      align="left"
                    />

                    <CardContent>
                      {firstQuizSet &&
                        firstQuizSet.length > 0 &&
                        firstQuizSet
                          .filter(
                            (quiz) =>
                              quiz && filterPromt.includes(quiz.type) && quiz.type === 'quiz' && quiz.botResponse
                          )
                          .map((quiz, index) =>
                            quiz.botResponse.map((data, idx) => {
                              try {
                                const changedValue = JSON.parse(data);
                                return changedValue.questions.map((value) => (
                                  <React.Fragment key={`${value.id}-${index}-${idx}`}>
                                    <Typography variant="body2" color="text.secondary" textAlign="left">
                                      Question Id: <b>{value.id}</b>
                                      <br />
                                      <br />
                                      <span>
                                        {'Question: '} {value.question_stem}
                                      </span>
                                      <br />
                                      <br />
                                    </Typography>
                                    {value.options.map((opt) => (
                                      <Typography
                                        key={`opt-${opt.id}-${value.id}`}
                                        variant="body2"
                                        color="text.secondary"
                                        textAlign="left"
                                      >
                                        {`${opt.id}. ${opt.distractor}`}
                                      </Typography>
                                    ))}
                                    <br />
                                    {value.options.map((feed) => (
                                      <Typography
                                        key={`feed-${feed.id}-${value.id}`}
                                        variant="body2"
                                        color="text.secondary"
                                        textAlign="left"
                                      >
                                        {`Feedback for answer choices: ${feed.id}. ${feed.feedback}`}
                                        <br />
                                        <br />
                                      </Typography>
                                    ))}
                                    <br />
                                  </React.Fragment>
                                ));
                              } catch (error) {
                                return (
                                  <Typography
                                    key={`error-${index}-${idx}`}
                                    variant="body2"
                                    color="text.secondary"
                                    textAlign="left"
                                  >
                                    {data}
                                  </Typography>
                                );
                              }
                            })
                          )}

                      <br />
                      <br />
                    </CardContent>
                  </Card>
                </Item>
                <br />
                <Item>
                  <Card
                    className={
                      dataValue.type === 'content_filter' ? classes.inCreaseAiStudyToolcard : classes.aiStudyToolcard
                    }
                  >
                    <CardHeader
                      title="AI Study Tool Response - Quiz Practice 2"
                      style={{ background: '#34282808' }}
                      align="left"
                    />

                    <CardContent>
                      {secondQuizSet &&
                        secondQuizSet.length > 0 &&
                        secondQuizSet
                          .filter(
                            (quiz) =>
                              quiz && filterPromt.includes(quiz.type) && quiz.type === 'quiz' && quiz.botResponse
                          )
                          .map((quiz, index) =>
                            quiz.botResponse.map((data, idx) => {
                              try {
                                const changedValue = JSON.parse(data);
                                return changedValue.questions.map((value) => (
                                  <React.Fragment key={`${value.id}-${index}-${idx}`}>
                                    <Typography variant="body2" color="text.secondary" textAlign="left">
                                      Question Id: <b>{value.id}</b>
                                      <br />
                                      <br />
                                      <span>
                                        {'Question: '} {value.question_stem}
                                      </span>
                                      <br />
                                      <br />
                                    </Typography>
                                    {value.options.map((opt) => (
                                      <Typography
                                        key={`opt-${opt.id}-${value.id}`}
                                        variant="body2"
                                        color="text.secondary"
                                        textAlign="left"
                                      >
                                        {`${opt.id}. ${opt.distractor}`}
                                      </Typography>
                                    ))}
                                    <br />
                                    {value.options.map((feed) => (
                                      <Typography
                                        key={`feed-${feed.id}-${value.id}`}
                                        variant="body2"
                                        color="text.secondary"
                                        textAlign="left"
                                      >
                                        {`Feedback for answer choices: ${feed.id}. ${feed.feedback}`}
                                        <br />
                                        <br />
                                      </Typography>
                                    ))}
                                    <br />
                                  </React.Fragment>
                                ));
                              } catch (error) {
                                return (
                                  <Typography
                                    key={`error-${index}-${idx}`}
                                    variant="body2"
                                    color="text.secondary"
                                    textAlign="left"
                                  >
                                    {data}
                                  </Typography>
                                );
                              }
                            })
                          )}

                      <br />
                      <br />
                    </CardContent>
                  </Card>
                </Item>
              </>

              {SubTypeData &&
                SubTypeData.map((typeData) => {
                  if (typeData && checkboxSelectedValue.chat_intent === true && typeData.type === 'chat_intent') {
                    return (
                      <>
                        <br />
                        <Item>
                          <Card className={classes.chatIntentCard}>
                            <CardHeader title="Chat Intent Response" style={{ background: '#34282808' }} align="left" />
                            <CardContent>
                              {typeData?.botResponse?.chatIntentResponse &&
                                typeData.botResponse.chatIntentResponse.length > 0 &&
                                typeData.botResponse.chatIntentResponse.map((data, index) => {
                                  return (
                                    <>
                                      {' '}
                                      {typeData.botResponse.chatIntentResponse.length > 1 && (
                                        <Typography variant="body2" color="text.secondary" textAlign="left">
                                          {index === 0 ? '[NORM-GPT]' : '[BAD-GPT]'}
                                        </Typography>
                                      )}
                                      {Object.entries(data).map(([key, value]) => {
                                        if (key !== 'blocklistsMatchResults' && key !== 'Category_Severity') {
                                          return (
                                            <Typography variant="body2" color="text.secondary" textAlign="left">
                                              {key} : {value}
                                            </Typography>
                                          );
                                        }
                                        return <></>;
                                      })}
                                      <br />
                                    </>
                                  );
                                })}
                            </CardContent>
                          </Card>
                        </Item>
                      </>
                    );
                  }
                  return <></>;
                })}

              <>
                <br />
              </>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
      <br />
    </>
  );
};

TopicQuizDialogComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  openChat: PropTypes.bool.isRequired,
  loaderStatusResponse: PropTypes.bool.isRequired,
  chatgptUtilityResponseStatus: shapes.state.isRequired,
  handleClose: PropTypes.func.isRequired,
  dataValue: PropTypes.object,
  dataLength: PropTypes.object,
  modalIndex: PropTypes.string,
  filterPromt: PropTypes.object,
  userTocDetails: PropTypes.object,
  handleModalChange: PropTypes.func.isRequired,
  chatgptUtilitySubTypeResponseStatus: shapes.state.isRequired,
  ChatUtilitySubTypeResponse: shapes.modelOf(SubTypeResponse).isRequired
};

TopicQuizDialogComponent.defaultProps = {
  modalIndex: '',
  filterPromt: [],
  dataValue: {},
  dataLength: {},
  userTocDetails: {}
};

export default withStyles(styles)(
  inject(
    'chatgptUtilityResponseStatus',
    'ChatUtilitySubTypeResponse',
    'chatgptUtilitySubTypeResponseStatus'
  )(observer(TopicQuizDialogComponent))
);
